import { Select } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiSelect-outlined': {
            background: 'white'
            // '& .MuiOutlinedInput-input': {
            //     background: 'white'
            // }
        }
    }
}));

function CustomSelect(props) {
    const classes = useStyles();

    const { children, disabled = false, formik, index = null, id, enableError = false } = props;
    const isError = () => {
        if (index !== null) {
            if (formik.touched?.[index] && formik.touched[index][id]) {
                return Boolean(formik.errors?.[index] && formik.errors[index][id]);
            }
            return false;
        }
        return formik.touched[id] && Boolean(formik.errors[id]);
    };
    return (
        <Select
            {...props}
            className={!disabled ? classes.root : ''}
            error={enableError ? isError() : false}
            // eslint-disable-next-line no-nested-ternary
            helperText={enableError && isError() ? (index !== null ? formik.errors[index][id] : formik.errors[id]) : false}
        >
            {children}
        </Select>
    );
}

export default CustomSelect;
